import { faEye } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, useCallback } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { colorStack } from '../../../../styleHelpers/colors';
import { useIntlMessage } from '../../IntlMessage';

const Wrapper = styled.button`
    cursor: pointer;
    color: ${colorStack.darkBlue};
    display: flex;
    align-items: center;
    span {
        margin: 0 0 0 .5rem;
        font-weight: 500;
    }
`;

interface IMultiStakeTemplateProps {
    props: any;
    field: string;
}

export const MultiStakeTemplate: FC<React.PropsWithChildren<IMultiStakeTemplateProps>> = ({ props, field }) => {
    const history = useNavigate();
    const { intlFormatMessage } = useIntlMessage();
    const handleRedirect = useCallback(() => {
        history(`/orgs/${props.organizationName}/cluster/${props.id}/overview?id=${props[field]}`);
    }, [props, field]);

    return (
        <Wrapper onClick={handleRedirect}>
            <FontAwesomeIcon icon={faEye} size="1x" />
            <span>{intlFormatMessage({id: 'cluster.seeAllValues'})}</span>
        </Wrapper>
    );
};